import MakePaymentConfirm from "./MakePaymentConfirm";
import RollingPayment from './RollingAgencyPayment';
export const RollingAgencyPayment = RollingPayment;
export default MakePaymentConfirm;